import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';

export const HOTEL_ROOM_CLICKED = 'HOTEL_ROOM_CLICKED';
export const HOTEL_ROOM_CLICKED_VERSION = '1.0';

export type HotelRoomClickedPayload = {
  internalHotelId: number;
  productDetailKey: string;
  providerId: string;
  roomId: string;
  searchId: string;
};

export type HotelRoomClickedParams = {
  searchId: string;
  initialParams: Pick<InitialParams, 'internalHotelId' | 'productDetailKey'>;
  room: Pick<RoomType, 'roomId'>;
  providerId: string;
};

export const createHotelRoomClickedPayload = ({
  searchId,
  initialParams: { internalHotelId, productDetailKey },
  room: { roomId },
  providerId,
}: HotelRoomClickedParams): HotelRoomClickedPayload => ({
  searchId,
  internalHotelId,
  roomId,
  providerId,
  productDetailKey,
});
